import { configureStore } from '@reduxjs/toolkit';
import headerReducer from '@/shared/store/slices/headerSlice';
import generalReducer from '@/shared/store/slices/generalSlice';

export const store = configureStore({
    reducer: {
        header: headerReducer,
        general: generalReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
